import { object, string } from 'yup';

import { createValidator } from '@src/validation';
import { textValidator } from '@src/validation/textValidator';
import { indicatorEditStore } from '@stores/dictionaryStores/indicatorsStore/indicatorEditStore';
import { indicatorsStore } from '@stores/dictionaryStores/indicatorsStore/indicatorsStore';

const validateSchema = object().shape({
  repVers: textValidator({ fieldName: 'repVers', required: false }),
  varText: textValidator({ fieldName: 'varText' }),
  sourceField: textValidator({ fieldName: 'sourceField' }),
  varSource: textValidator({ fieldName: 'varSource' }),
  varCode: textValidator({ fieldName: 'varCode' }).test(
    'code',
    'Показатель должен быть уникальным',
    (value, { parent: { id } }) => {
      const { indicators } = indicatorsStore;
      const { isNew } = indicatorEditStore;

      if (isNew) return !indicators.some((indicator) => indicator.varCode === value && indicator.id !== id);
      return true;
    },
  ),
  decimalQty: string().when('roundingType', {
    is: (v) => v !== null && v !== undefined,
    then: string().nullable().required(),
    otherwise: string().nullable().notRequired(),
  }),
});

export const validate = createValidator(validateSchema);
